// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2hfTR","messages":"Chat_messages__10kqd","dateDivider":"Chat_dateDivider__3wglr"};